import { TMetaPrimitives } from '@cian/logger/shared';

import {
  fetchDeleteMessage,
  IDeleteMessageRequest,
  TDeleteMessageResponse,
} from '../repositories/chats/v1/delete-message';
import { TContext } from '../types/context';

type TFetchDeleteMessageParams = {
  parameters: IDeleteMessageRequest;
  cookies?: string;
};

export async function performDeleteMessage(
  { logger, httpApi }: TContext,
  { cookies, parameters }: TFetchDeleteMessageParams,
): Promise<boolean> {
  try {
    const { response, statusCode }: TDeleteMessageResponse = await fetchDeleteMessage({
      httpApi,
      parameters,
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      logger.warning(response.message || /* istanbul ignore next */ 'Код ответа не 200', {
        domain: 'src/shared/services/performDeleteMessage.ts [performDeleteMessage]',
        message: 'Не удалось получить список архивных чатов',
        errors: response.errors as unknown as TMetaPrimitives[],
      });

      return false;
    }

    return true;
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/performDeleteMessage.ts [performDeleteMessage]',
      message: 'Не удалось получить список архивных чатов',
    });

    return false;
  }
}
